export const SENTRY_EPPO = 'EPPO';
